import React, { Component } from 'react'
import './Bloc.css'

class BlocLoading extends Component {
    render() {
        const style = {}
        style.display = 'table'

        if (this.props.height && this.props.height !== undefined) {
            style.minHeight = this.props.height + 'px'
        } else {
            style.minHeight = '165px'
        }

        return (
            <div>
                <div className="Bloc BlocLoading fade-in bloc-full" style={style}>
                    <div className="simpleDoubleWord1 bold-font">
                        {this.props.message_principal}
                    </div>
                    <div>
                        {' '}
                        <img
                            src="loading.gif"
                            className="loading-end-gif"
                            alt="Chargement icon"
                        />
                    </div>
                    <div className="simpleDoubleWord2">
                        {this.props.petite_ligne_1}
                    </div>
                    <div className="simpleDoubleWord2">
                        {this.props.petite_ligne_2}
                    </div>
                </div>
            </div>
        )
    }
}

export default BlocLoading
